import { Theme } from "@mui/material";

export const getPickerStyles = (isRequestDay: boolean, bgColor?: string) => {
  const defaultBgColor = isRequestDay ? bgColor : "transparent";
  const defaultCursor = isRequestDay ? "pointer" : "default";

  return {
    fontWeight: 700,
    bgcolor: defaultBgColor,
    borderRadius: "0.25rem",
    cursor: defaultCursor,

    "&:hover, &:focus": {
      bgcolor: defaultBgColor,
    },

    "&.Mui-selected": {
      bgcolor: defaultBgColor,
      color: "text.primary",
      fontWeight: 400,

      "&:hover, &:focus": {
        bgcolor: defaultBgColor,
      },
    },

    "&:not(.Mui-selected)": {
      borderColor: "primary.dark",
    },
  };
};

export const getPaperStyles = (theme: Theme) => ({
  maxWidth: "fit-content",
  margin: "0 auto",

  [theme.breakpoints.up("sm")]: {
    margin: "0",
  },
});

export const calendarDrawerStyles = {
  ".MuiDrawer-paper": {
    borderRadius: "26px 26px 0px 0px",
    padding: "2rem 1.5rem 2rem",
  },
};
